import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  divider: {
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing(2, 0),
    '&::before, &::after': {
      content: '""',
      flex: 1,
      height: '1px',
      backgroundColor: theme.colorPalette.beige_60
    }
  },
  label: {
    padding: theme.spacing(0, 4),
    color: theme.colorPalette.green_100,
    fontSize: 12,
    fontWeight: 400
  }
}));

export default useStyles;
